import { render } from "./childItem.vue?vue&type=template&id=6e250a3c&scoped=true"
import script from "./childItem.vue?vue&type=script&lang=js"
export * from "./childItem.vue?vue&type=script&lang=js"

import "./childItem.vue?vue&type=style&index=0&id=6e250a3c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6e250a3c"

export default script